import type {TuiCountryIsoCode, TuiLanguage, TuiLanguageCommerce, TuiLanguageCore, TuiLanguageEditor, TuiLanguageKit, TuiLanguageLayout, TuiLanguageTable} from '@taiga-ui/i18n/types';

export const TUI_NORWEGIAN_LANGUAGE_ADDON_COMMERCE: TuiLanguageCommerce = {
    cardNumber: ['Nummer', 'Kortnummer'],
    cardExpiry: ['Utløp', 'Utløpsdato'],
};

export const TUI_NORWEGIAN_LANGUAGE_LAYOUT: TuiLanguageLayout = {
    inputSearch: {
        popular: 'Populært',
        history: 'Nylig',
        placeholder: 'Søk',
        hotkey: 'for å søke',
        all: 'Alle',
        empty: 'Ingen resultater',
    },
};

export const TUI_NORWEGIAN_LANGUAGE_KIT: TuiLanguageKit = {
    cancel: 'Avbryt',
    done: 'Ferdig',
    more: 'Mer',
    otherDate: 'Annen dato...',
    showAll: 'Vis alle',
    hide: 'Skjul',
    mobileCalendarTexts: [
        'Velg dag',
        'Velg periode',
        'Velg dager',
    ],
    range: ['Fra', 'Til'],
    countTexts: ['Mer', 'Mindre'],
    time: {
        'HH:MM': 'HH:MM',
        'HH:MM AA': 'HH:MM AA',
        'HH:MM:SS': 'HH:MM:SS',
        'HH:MM:SS AA': 'HH:MM:SS AA',
        'HH:MM:SS.MSS': 'HH:MM:SS.MSS',
        'HH:MM:SS.MSS AA': 'HH:MM:SS.MSS AA',
    },
    dateTexts: {
        DMY: 'dag.måned.år',
        MDY: 'måned.dag.år',
        YMD: 'år.måned.dag',
    },
    digitalInformationUnits: ['Byte', 'Kilobyte', 'Megabyte'],
    passwordTexts: ['Vis passord', 'Skjul passord'],
    copyTexts: ['Kopier', 'Kopiert'],
    shortCalendarMonths: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'Mai',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Okt',
        'Nov',
        'Des',
    ],
    pagination: ['Forrige side', 'Neste side'],
    fileTexts: {
        loadingError: 'Lastefeil',
        preview: 'Forhåndsvis',
        remove: 'Fjern',
    },
    inputFileTexts: {
        defaultLabelSingle: 'eller slipp den her',
        defaultLabelMultiple: 'eller slipp dem her',
        defaultLinkSingle: 'Velg fil',
        defaultLinkMultiple: 'Velg filer',
        maxSizeRejectionReason: 'Filen er for stor',
        formatRejectionReason: 'Ugyldig filformat',
        drop: 'Slipp fil her',
        dropMultiple: 'Slipp filer her',
    },
    multiSelectTexts: {
        all: 'Velg alle',
        none: 'Velg ingen',
    },
    confirm: {
        yes: 'Ja',
        no: 'Nei',
    },
    previewTexts: {
        rotate: 'Roter',
    },
    zoomTexts: {
        zoomOut: 'Zoom ut',
        zoomIn: 'Zoom inn',
        reset: 'Tilbakestill',
    },
    phoneSearch: 'Søk land eller kode',
};

export const TUI_NORWEGIAN_LANGUAGE_ADDON_EDITOR: TuiLanguageEditor = {
    colorSelectorModeNames: ['Enkeltfarge', 'Fargegradient'],
    toolbarTools: {
        undo: 'Angre',
        redo: 'Gjør om',
        font: 'Skrift',
        fontStyle: 'Skriftstil',
        fontSize: 'Skriftstørrelse',
        bold: 'Fet',
        italic: 'Kursiv',
        underline: 'Understreket',
        strikeThrough: 'Gjennomstreket',
        justify: 'Juster',
        justifyLeft: 'Venstrejuster',
        justifyCenter: 'Sentrer',
        justifyRight: 'Høyrejuster',
        justifyFull: 'Blokkjuster',
        list: 'Liste',
        indent: 'Øk innrykk',
        outdent: 'Reduser innrykk',
        unorderedList: 'Punktliste',
        orderedList: 'Nummerert liste',
        quote: 'Sitat',
        foreColor: 'Tekstfarge',
        backColor: 'Bakgrunnsfarge',
        hiliteColor: 'Markeringsfarge',
        clear: 'Tøm',
        link: 'Lenke',
        attach: 'Legg ved fil',
        tex: 'Sett inn TeX',
        code: 'Kode',
        image: 'Sett inn bilde',
        insertHorizontalRule: 'Sett inn horisontal linje',
        superscript: 'Hevet skrift',
        subscript: 'Senket skrift',
        insertTable: 'Sett inn tabell',
        insertGroup: 'Sett inn gruppe',
        hiliteGroup: 'Marker gruppe',
        removeGroup: 'Fjern gruppe',
        insertAnchor: 'Sett inn anker',
        mergeCells: 'Slå sammen celler',
        splitCells: 'Del celler',
        rowsColumnsManaging: 'Håndter rader og kolonner',
        cellColor: 'Cellefarge',
        setDetails: 'Angi detaljer',
        removeDetails: "Fjern detaljer",
    },
    editorEditLink: {
        urlExample: 'eksempel.com',
        anchorExample: 'anker',
    },
    editorTableCommands: [
        ['Sett inn kolonne før', 'Sett inn kolonne etter'],
        ['Sett inn rad før', 'Sett inn rad etter'],
        ['Fjern kolonne', 'Fjern rad'],
    ],
    editorCodeOptions: ['Kode i tekst', 'Kodeblokk'],
    editorFontOptions: {
        small: 'Liten',
        large: 'Stor',
        normal: 'Normal',
        title: 'Tittel',
        subtitle: 'Undertittel',
    },
};

export const TUI_NORWEGIAN_LANGUAGE_ADDON_TABLE: TuiLanguageTable = {
    showHideText: 'Vis/Skjul',
    paginationTexts: {
        pages: 'Sider',
        linesPerPage: 'Rader per side',
        of: 'av',
    },
};

export const TUI_NORWEGIAN_LANGUAGE_CORE: TuiLanguageCore = {
    months: [
        'Januar',
        'Februar',
        'Mars',
        'April',
        'Mai',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'Desember',
    ],
    close: 'Lukk',
    clear: 'Tøm',
    nothingFoundMessage: 'Ingen resultater',
    defaultErrorMessage: 'Ugyldig verdi',
    spinTexts: ['Forrige', 'Neste'],
    shortWeekDays: ['Man', 'Tir', 'Ons', 'Tor', 'Fre', 'Lør', 'Søn'],
    countries: {} as Record<TuiCountryIsoCode, string>,
};

export const TUI_NORWEGIAN_LANGUAGE: TuiLanguage = {
    name: 'norwegian',
    ...TUI_NORWEGIAN_LANGUAGE_CORE,
    ...TUI_NORWEGIAN_LANGUAGE_KIT,
    ...TUI_NORWEGIAN_LANGUAGE_ADDON_TABLE,
    ...TUI_NORWEGIAN_LANGUAGE_ADDON_COMMERCE,
    ...TUI_NORWEGIAN_LANGUAGE_ADDON_EDITOR,
    ...TUI_NORWEGIAN_LANGUAGE_LAYOUT,
};